'use strict';

import {wpModel} from "../../models/wpmodel.js";
import {continousRiskModel} from "../../models/continousriskmodel.js";
import {reportingModel} from "@js/models/reportingmodel";
import {participantModel} from "@js/models/participantmodel";

export class ProjectReportsCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	fieldCfg = {};
	workpackages = [];
	instruction = '';
	risks = [];
	comment;
	reportings = {
		t1: [],
		t2: [],
		t3: []
	};
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
//		this.workpackages = new projectModel(jsDataService.get('workpackages', {}), $filter, jsDataService);
		this.initWP(jsDataService.get('workpackages', {}));
		this.initRisk(jsDataService.get('risks', {}));
		this.risksPreviewUrl = jsDataService.get('risksPreviewUrl');
		this.risksEditUrl = jsDataService.get('risksEditUrl');
		this.commentUrl = jsDataService.get('commentUrl');
		this.comment = jsDataService.get('comment');
		this.dataReportingsConstruct();
		this.instruction = this.$filter('tr')('project_instruction_tooltip');
		this.filterBeneficiary = function(beneficiary) {
			return beneficiary.value > 0 || beneficiary.completion > 0;
		};
	}

	dataReportingsConstruct(){
		if(typeof(this.jsDataService.data.reportings) !== 'undefined'){
			this.setReportings(this.jsDataService.data.reportings);
		}
	}

	setReportings(reportings){
		this.reportings = {
			t1: [],
			t2: [],
			t3: []
		};
		if(typeof(reportings.t1) !== 'undefined' || typeof(reportings.t2) !== 'undefined' || typeof(reportings.t3) !== 'undefined'){
			for(let id in reportings){
				for(let reportingData of reportings[id]){
					this.reportings[id].push(new reportingModel(reportingData, this.$filter, this.jsDataService));
				}
			}
		}
	}

	initWP(rawWps) {
		this.workpackages = rawWps.map(wpData => {
			if (wpData.beneficiaries && !Array.isArray(wpData.beneficiaries)) {
				wpData.beneficiaries = Object.values(wpData.beneficiaries);
			}

			if (Array.isArray(wpData.beneficiaries)) {
				wpData.beneficiaries.forEach(b => {
					b.completion = b.completion != null
						? parseFloat(b.completion)
						: 0;
				});
			}
            if (wpData.locked) {
                wpData.completion_status = 2;
                wpData.completion = 100;
                wpData.accepted_amount = wpData.total_grant;
                wpData.rejected_amount = 0;
            }

			return new wpModel(wpData, this.$filter, this.jsDataService);
		});

		this.updateUniqueBeneficiaries();
	}

	initRisk(risks){
		this.risks = [];
		for(let wp of risks){
			this.risks.push(new continousRiskModel(wp, this.$filter, this.jsDataService));
		}
	}
	isPreview(node){
		return (typeof(node.preview_url) !== 'undefined');
	}
	
	isEdit(node){
		return (typeof(node.edit_url) !== 'undefined');
	}
	
	actionPreview(ev, node){
		if(this.isPreview(node)){
			this.$scope.goUrl(node.preview_url);
		}
	}
	
	actionEdit(ev, node){
		if(this.isEdit(node)){
			this.$scope.goUrl(node.edit_url);
		}
	}
	
	isField(name){
		return (typeof(this.fieldCfg[name]) !== 'undefined');
	}

	/////
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}

	getParticipant(id){
		if(typeof(this.jsDataService.data.participants) === 'undefined'){
			return null;
		}
		let prtcps = this.$filter('filter')(this.jsDataService.data.participants, {id: id}, true);
		if(prtcps.length < 1){
			return null;
		}
		return new participantModel(prtcps[0], this.$filter, this.jsDataService);
	}

	getParticipantField(id, field){
		if(id && typeof(id) === 'object'){
			let fields = [];
			for(let oneId of Object.values(id)){
				let participant = this.getParticipant(oneId);
				if(!participant){
					continue;
				}
				fields.push(participant.getValue(field));
			}
			if(fields.length > 0){
				return fields.join(', ');
			}
			return '';
		}
		else{
			let participant = this.getParticipant(id);
			if(!participant){
				return '';
			}
			return participant.getValue(field);
		}
	}
	filterCompletionStatus(wp) {
		return wp.completion_status > 0;
	}

	sumTotalGrant() {
		return this.workpackages
			.filter(this.filterCompletionStatus)
			.reduce((acc, wp) => acc + this.getWpBeneficiariesSum(wp), 0);
	}

	updateUniqueBeneficiaries() {
		const uniqueMap = {};
		const filteredWps = this.workpackages.filter(this.filterCompletionStatus);

		filteredWps.forEach(wp => {
			let beneficiaries = wp.beneficiaries;
			if (!beneficiaries) return;

			if (!Array.isArray(beneficiaries)) {
				beneficiaries = [beneficiaries];
			}

			beneficiaries.forEach(ben => {
				if (!ben.participant_id || ben.participant_id === 0) {
					return;
				}
				const key = ben.participant_id;
				if (!uniqueMap[key]) {
					uniqueMap[key] = angular.copy(ben);
					uniqueMap[key].compositeKey = key;
				}
			});
		});

		this.uniqueBeneficiaries = Object.values(uniqueMap);
	}


	getBeneficiaryAcceptedAmount(wp, beneficiary) {
		if (!wp || !wp.beneficiaries) return 0;

		const beneficiaries = Array.isArray(wp.beneficiaries)
			? wp.beneficiaries
			: [wp.beneficiaries];

		const matchingBen = beneficiaries.find(b =>
			b.participant_id === beneficiary.participant_id &&
			b.application_wp_id === wp.wp_id
		);

		if (!matchingBen) {
			return 0;
		}

		if (matchingBen.accepted_amount !== undefined && matchingBen.accepted_amount !== null) {
			return parseFloat(matchingBen.accepted_amount) > 0 ? parseFloat(matchingBen.accepted_amount) : 0;
		}

		if (wp.completion_status != 1) {
			return matchingBen.value;
		}

		const completion = parseFloat(matchingBen.completion) || 0;
		const totalGrant = parseFloat(wp.total_grant) || 0;
		return totalGrant / 100 * completion;
	}


	getBeneficiaryRowSum(beneficiary) {
		const filteredWps = this.workpackages.filter(this.filterCompletionStatus);
		let total = 0;

		filteredWps.forEach(wp => {
			const beneficiaries = Array.isArray(wp.beneficiaries)
				? wp.beneficiaries
				: [wp.beneficiaries];
			const matchingBen = beneficiaries.find(b =>
				b.participant_id === beneficiary.participant_id &&
				b.application_wp_id === wp.wp_id
			);
			if (!matchingBen) return;

			if (wp.completion_status != 1) {
				total += parseFloat(matchingBen.value) || 0;
			} else if (matchingBen.accepted_amount !== undefined && matchingBen.accepted_amount !== null) {
				total += parseFloat(matchingBen.accepted_amount);
			} else {
				const completion = parseFloat(matchingBen.completion) || 0;
				const totalGrant = parseFloat(wp.total_grant) || 0;
				total += (totalGrant * completion) / 100;
			}
		});

		return total;
	}


	getWpBeneficiariesSum(wp) {
		if (!wp || !wp.beneficiaries) return 0;

		const beneficiaries = Array.isArray(wp.beneficiaries) ? wp.beneficiaries : [wp.beneficiaries];
		let sum = 0;

		beneficiaries.forEach(b => {
			if (b.application_wp_id === wp.wp_id) {
				if (wp.completion_status != 1) {
					sum += parseFloat(b.value) || 0;
				} else if (b.accepted_amount !== undefined && b.accepted_amount !== null) {
					sum += parseFloat(b.accepted_amount);
				} else {
					const completion = parseFloat(b.completion) || 0;
					const totalGrant = parseFloat(wp.total_grant) || 0;
					sum += (totalGrant / 100) * completion;
				}
			}
		});

		return sum;
	}

	getAffiliatedValue(wp, beneficiaryId) {
		return '';
	}

	updateCompletion(wp) {
		if (parseInt(wp.completion_status, 10) == 0) {
			wp.completion = 0;
			wp.accepted_amount = 0;
//			wp.rejected_amount = wp.total_grant;
			wp.rejected_amount = 0;
			if(wp.completion > 0){
				wp.rejected_amount = parseFloat(wp.total_grant * (wp.completion / 100)).toFixed(2) ;
			}
		} else if (parseInt(wp.completion_status, 10) == 2) {
			wp.completion = 100;
			wp.accepted_amount = wp.total_grant;
			wp.rejected_amount = 0;
		}
		else if (parseInt(wp.completion_status, 10) == 1) {

		}
	}

	loadData() {
		const url = this.jsDataService.get('cfgDataUrl');
		if(url) {
			this.promise = this.$scope.basicHttpConfigProcess({
				url: url,
				method: 'GET',
				params: {}
			}).then((response) => {
				if(response.data.success){
					this.initWP(response.data.data.workpackages || []);
					this.initRisk(response.data.data.risks || []);
					this.dataReportingsConstruct();
					this.jsDataService.data = Object.assign({}, this.jsDataService.data, response.data.data);
				}
			}, () => {
			});
		}
	}


	editWpChecklist(ev, wp){
		this.wpChecklistEditor(ev, wp);
	}
	wpChecklistEditor(ev, wp){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "wp", "fieldCfg", this.wpChecklistEditorDialogCtrl],
			templateUrl: 'projects/ng_periodic_checklist_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				wp: wp,
				fieldCfg: this.fieldCfg
			}
		}).then((results) => {
			if(this.jsDataService.get('cfgWpSaveUrl')){
				this.isSaved = false;
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgWpSaveUrl'),
					method: 'POST',
					data: results
				}).then((response) => {

					if(response.data.success){
						this.loadData();
					}
					this.isSaved = true;

				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgSaveUrl'));
			}
		}, () => {});
	}

	wpChecklistEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, originalWp, fieldCfg) {
		$scope.wp = angular.copy(originalWp);
		$scope.wp.classif = jsDataService.data.cfgClassif;
		$scope.initialStatus = originalWp.completion_status;

		angular.forEach($scope.wp.beneficiaries, (b) => {
			b.completion       = (b.completion       !== undefined) ? parseFloat(b.completion)       : 0;
			b.accepted         = (b.accepted         !== undefined) ? parseFloat(b.accepted)         : 0;
			b.accepted_amount  = (b.accepted_amount  !== undefined) ? parseFloat(b.accepted_amount)  : 0;
			b.rejected_amount  = (b.rejected_amount  !== undefined) ? parseFloat(b.rejected_amount)  : 0;
			b.value            = (b.value            !== undefined) ? parseFloat(b.value)            : 0;
			b.declared_amount  = (b.declared_amount  !== undefined) ? parseFloat(b.declared_amount)  : (b.value * (b.completion / 100));
		});

		if (!$scope.wp.rows || !$scope.wp.rows.length) {
			$scope.wp.rows = [{
				completion: 0,
				accepted: 0,
				declared_amount: 0,
				accepted_amount: 0,
				rejected_amount: 0,
				rejected_comment: '',
				total_grant: $scope.wp.total_grant || 0
			}];
		}

		$scope.initRow = function(wp) {
//			if (wp.completion_status == 2) {
//				return 100;
//			}
//			if (wp.completion_status == 0) {
//				return 0;
//			}
		};
		
		$scope.calculateRow = function(wp) {
			const total_grant = (wp.total_grant !== undefined) ? wp.total_grant : ($scope.wp.total_grant || 0);
			wp.accepted_amount = parseFloat((total_grant * (parseFloat(wp.accepted) || 0 / 100)).toFixed(2));
			wp.rejected_amount = parseFloat((wp.declared_amount - wp.accepted_amount).toFixed(2));
			wp.rejected_comment = wp.rejected_comment || '';
//			const pct = parseFloat(wp.completion) || 0;
//			const total_grant = (wp.total_grant !== undefined) ? wp.total_grant : ($scope.wp.total_grant || 0);
//			wp.accepted = parseFloat((total_grant * (pct / 100)).toFixed(2));
//			wp.rejected_amount = parseFloat((total_grant - wp.accepted).toFixed(2));
//			wp.accepted_amount = parseFloat((total_grant - wp.rejected_amount).toFixed(2));
//			wp.rejected_comment = wp.rejected_comment || '';
			if ($scope.wp.completion_status == 1) {
				$scope.calculateTotals();
			}
		};

		$scope.calculateTotals = function() {
			let sumAccepted = 0, sumRejected = 0;
			angular.forEach($scope.wp.rows, (wp) => {
				sumAccepted += wp.accepted_amount || 0;
				sumRejected += wp.rejected_amount || 0;
			});

			$scope.totalAccepted = parseFloat(sumAccepted.toFixed(2));
			$scope.totalRejected = parseFloat(sumRejected.toFixed(2));
		};

		$scope.addRow = function() {
			$scope.wp.rows.push({
				completion: 0,
				accepted: 0,
				declared_amount: 0,
				accepted_amount: 0,
				rejected_amount: 0,
				rejected_comment: '',
				total_grant: $scope.wp.total_grant || 0
			});
		};

		$scope.calculateBeneficiary = function(ben) {
			const beneficiaryValue = parseFloat(ben.value) || 0;
			let pct = parseFloat(ben.accepted) || 0;

			if (pct > 100) {
				pct = 100;
				ben.accepted = 100;
			}
			ben.accepted_amount = parseFloat((beneficiaryValue * (pct / 100)).toFixed(2));
			ben.rejected_amount = parseFloat((ben.declared_amount - ben.accepted_amount).toFixed(2));
			$scope.calculateBeneficiariesTotals();
		};

		$scope.calculateBeneficiariesTotals = function() {
			let sumAccepted = 0, sumRejected = 0, sumPercent = 0;
			angular.forEach($scope.wp.beneficiaries, (b) => {
				sumAccepted += b.accepted_amount || 0;
				sumRejected += b.rejected_amount || 0;
				sumPercent  += b.accepted || 0;
			});

			$scope.totalAccepted = parseFloat(sumAccepted.toFixed(2));
			$scope.totalRejected = parseFloat(sumRejected.toFixed(2));
			$scope.totalPercent  = parseFloat(sumPercent.toFixed(10));
		};

//		if ($scope.wp.completion_status == 1) {
//			$scope.calculateTotals();
//		}
//		$scope.calculateBeneficiariesTotals();

		$scope.filterBeneficiary = function(beneficiary) {
			return beneficiary.value > 0 || beneficiary.completion > 0;
		};


		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			const status = parseInt($scope.wp.completion_status, 10);
			const wpData = {
				id: $scope.wp.wp_id,
				completion_status: status,
				completion: $scope.wp.completion,
				report_id: $scope.wp.report_id,
				project_id: $scope.wp.project_id,
				accepted: $scope.wp.accepted,
				accepted_amount: $scope.wp.accepted_amount,
				rejected_amount: $scope.wp.rejected_amount,
				rejected_comment: $scope.wp.rejected_comment || '',
				beneficiaries: []
			};

			if (status === 1 && Array.isArray($scope.wp.beneficiaries) && $scope.wp.beneficiaries.length) {
				for (const b of $scope.wp.beneficiaries) {
					const found = $filter('filter')(jsDataService.data.participants, { id: b.participant_id }, true);
					let participantId = found && found.length ? found[0].id : null;
					wpData.beneficiaries.push({
						id: participantId,
						acronym: b.acronym || '',
						status: b.status || 0,
						report_id: b.report_id,
						project_id: b.project_id,
						completion: b.completion || 0,
						accepted: b.accepted || 0,
						accepted_amount: b.accepted_amount || 0,
						rejected_amount: b.rejected_amount || 0,
						rejected_comment: b.rejected_comment || ''
					});
				}
			} else {
				wpData.noBen = true;
				wpData.beneficiaries = [{
					id: 0,
					acronym: '',
					status: status,
					report_id: wpData.report_id,
					project_id: wpData.project_id,
					completion: wpData.completion || 0,
					accepted: wpData.accepted,
					accepted_amount: wpData.accepted_amount,
					rejected_amount: wpData.rejected_amount,
					rejected_comment: wpData.rejected_comment || ''
				}];
			}

			const postData = { workpackages: [wpData] };
			$mdDialog.hide(postData);
		};


		$scope.updateCompletion = function(localWp) {
//			if (parseInt(localWp.completion_status, 10) === 0) {
//				localWp.completion = 0;
//				localWp.accepted = localWp.completion;
//				localWp.accepted_amount = 0;
//				localWp.rejected_amount = localWp.total_grant;
//			} else if (parseInt(localWp.completion_status, 10) === 2) {
//				localWp.completion = 100;
//				localWp.accepted = localWp.completion;
//				localWp.accepted_amount = localWp.total_grant;
//				localWp.rejected_amount = 0;
//			}
//			// Optionally, if needed, update totals:
//			$scope.calculateTotals();
		};

//		$scope.$watch('beneficiary.completion', function(newVal) {
//			if (newVal !== undefined && newVal !== null && newVal !== '') {
//				const parsed = parseFloat(newVal);
//				if (!isNaN(parsed)) {
//					$scope.beneficiary.completion = parsed.toFixed(10);
//				}
//			}
//		});

		$scope.$watch('wp.completion_status', function(newVal) {
			if (newVal == 2) {
//				$scope.wp.completion = 100;
				$scope.wp.accepted = 100;
				$scope.wp.accepted_amount = $scope.wp.total_grant;
				$scope.wp.rejected_amount = 0;
			} else if (newVal == 0) {
				// $scope.wp.completion = 0;
				// $scope.wp.accepted = $scope.wp.completion;
				$scope.wp.accepted = 0;
				$scope.wp.accepted_amount = 0;
//				$scope.wp.rejected_amount = $scope.wp.total_grant;
				$scope.wp.rejected_amount = 0;
				if($scope.wp.completion > 0){
					$scope.wp.rejected_amount = parseFloat($scope.wp.total_grant * ($scope.wp.completion / 100)).toFixed(2) ;
				}
			}
//			$scope.calculateAllTotals();
			initCalculations();
		});
		
		$scope.statusDisabled = function(status){
			switch(status.id){
				case '0':
					if($scope.wp.max_completion_pc > 0){
						return true;
					}
					if($scope.initialStatus == '1'){
						return true;
					}
					break;
				case '1':
					if($scope.wp.min_completion_pc >= 100){
						return true;
					}
					if(!$scope.wp.is_Unit_or_FNLC && !$scope.wp.belongs_to_final_reporting){
						return true;
					}
					break;
				case '2':
					if($scope.wp.max_completion_pc > 0){
						return true;
					}
					if($scope.initialStatus == '1'){
						return true;
					}
					break;
			}
			return false;
		};
		
		$scope.calculateAllTotals = function(){
			if($scope.wp.completion_status == 1 && ($scope.wp.belongs_to_final_reporting || $scope.wp.is_Unit_or_FNLC)){
				
				$scope.calculateBeneficiariesTotals();
			}
			else{
				$scope.calculateTotals();
			}
		};
		
		function initCalculations(){
			if($scope.wp.completion_status == 1 && ($scope.wp.belongs_to_final_reporting || $scope.wp.is_Unit_or_FNLC)){
				angular.forEach($scope.wp.beneficiaries, (b) => {
					$scope.calculateBeneficiary(b);
				});
			}
			$scope.calculateAllTotals();
		}
		
//		$scope.calculateAllTotals();
	}

	getCompletionStatusTitle(statusId) {
		if (!this.classif || !this.classif.periodic_completion_status) {
			return 'Unknown';
		}
		const status = this.classif.periodic_completion_status.find(item => item.id == statusId);
		return status ? status.title : 'Unknown';
	}

    manageFiles(ev, wp){
        this.wFilesEditor(ev, wp);
    }

    wFilesEditor(ev, wp){
        this.$mdDialog.show({
            controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "notify", "wp", this.wpFileEditorDialogCtrl],
            templateUrl: 'projects/ng_periodic_wp_file_editor.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: { wp: wp }
        }).then((results) => {
            this.postAction(wp, results);
        }, () => {});
    }

    wpFileEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, notify, wp){
        $scope.fileFilter = jsDataService.get('cfgFileFilter', {});
        $scope.maxFileSize = jsDataService.get('maxFileSize', 0);
        $scope.uploadUrl = jsDataService.get('cfgUploadUrl');
        $scope.attfile = { file: {}, flow: null };
        $scope.dragClass = '';
        $scope.wp = wp;
        $scope.classif = angular.copy(jsDataService.get('cfgClassif', {}));

        $scope.extraQuery = {
            project_id: $scope.wp.project_id,
            report_id: $scope.wp.report_id,
            wp_id: $scope.wp.id,
            return: 'item'
        };

        function parseMsg(msg){
            if(typeof msg === 'string'){
                try { return JSON.parse(msg); } catch(e){ return {}; }
            }
            return msg || {};
        }

        $scope.fileUploaded = function($file, $message, $flow){
            const r = parseMsg($message);
            if(r && r.success){
                if(r.fileId){
                    $scope.attfile.file.file_id = r.fileId;
                }
                $scope.attfile.file.done = true;
                $scope.saveAttachment($scope.attfile);
            }
        };

        $scope.filesAdded = function($files, $event, $flow){
            if($flow && !$scope.attfile.flow){
                $scope.attfile.flow = $flow;
            }
            return true;
        };

        $scope.fileAdded = function($file, $event, $flow){
            const ext = $file.getExtension();
            if(typeof($scope.fileFilter[ext]) === 'undefined' || !$scope.fileFilter[ext]){
                notify($filter('tr')('file_wrong_format'), true);
                return false;
            }
            if(typeof($scope.maxFileSize) !== 'undefined' && $file.size > $scope.maxFileSize){
                notify($file.name + ' - ' + $filter('tr')('file_size_error'), true);
                return false;
            }
            if(!$scope.activeUpload()){
                return false;
            }
            if($flow && !$scope.attfile.flow){
                $scope.attfile.flow = $flow;
            }
            $scope.addFlowFile($file);
            return true;
        };

        $scope.fileSubmited = function(){
            if($scope.attfile.flow){
                $scope.attfile.flow.upload();
            }
        };

        $scope.activeUpload = function(){
            return true;
        };

        $scope.classOnDrag = function(value){
            if($scope.activeUpload()){
                $scope.dragClass = value;
            }
        };

        $scope.classOffDrag = function(value){
            $scope.dragClass = value;
        };

        $scope.addFlowFile = function($file){
            $scope.attfile.file = {
                file_id: '0',
                nrId: $file.uniqueIdentifier,
                file_name: $file.name,
                isFlow: true,
                flowFile: $file,
                done: false
            };
        };

        $scope.editDisabled = function(){
            return ($scope.wp.status == 2);
        };

        $scope.saveAttachment = function(attachment){
            if($scope.editDisabled()){
                return;
            }
            let data = {
                file_id: attachment.file.file_id,
                title: attachment.file.file_name.replace(/\.[a-z0-9]+$/, ''),
                report_id: $scope.wp.report_id,
                project_id: $scope.wp.project_id,
                wp_id: $scope.wp.id
            };
            if($scope.wp.file_add_url && $scope.wp.file_add_url !== ''){
                $scope.$root.basicHttpConfigProcess({
                    url: $scope.wp.file_add_url,
                    method: 'POST',
                    data: data
                }).then((response) => {
                    if(response.data.success && typeof(response.data.item) !== 'undefined'){
                        wp.status = response.data.item.status;
                        $scope.wp.status = response.data.item.status;
                        $scope.wp.attachments = response.data.item.attachments;
                        $scope.attfile.file = {};
                    }
                }, () => {});
            }
            else{
                console.log('no url ', $scope.wp.file_add_url);
            }
        };

        $scope.removeAttachment = function(ev, attachment){
            if($scope.editDisabled()){
                return;
            }
            if($scope.wp.file_remove_url !== ''){
                const confirmTexts = jsDataService.get('attachmentRemoveConfirmTexts');
                const confirm = $mdDialog.confirm()
                    .title(confirmTexts.title)
                    .htmlContent(confirmTexts.content)
                    .ariaLabel(confirmTexts.title)
                    .targetEvent(ev)
                    .ok(confirmTexts.ok)
                    .multiple(true)
                    .cancel(confirmTexts.cancel);
                $mdDialog.show(confirm).then(() => {
                    $scope.$root.basicHttpConfigProcess({
                        url: $scope.wp.file_remove_url,
                        method: 'GET',
                        responseType: 'json',
                        params: {
                            id: attachment.id,
                            project_id: $scope.wp.project_id,
                            report_id: $scope.wp.report_id,
                            wp_id: $scope.wp.id
                        }
                    }).then((response) => {
                        if(response.data.success && typeof(response.data.item) !== 'undefined'){
                            wp.status = response.data.item.status;
                            $scope.wp.status = response.data.item.status;
                            $scope.wp.attachments = response.data.item.attachments;
                        }
                    });
                }, () => {});
            }
        };

        $scope.close = function() {
            $mdDialog.cancel();
        };

        $scope.isValid = function(){
            if($scope.editDisabled()){
                return false;
            }
            return ($scope.wp.attachments && $scope.wp.attachments.length>0 && $scope.wp.description!=='');
        };

        $scope.allowRemoveSite = function(attachment){
            return (attachment.allowremove);
        };

        $scope.getClassif = function(name){
            if(typeof($scope.classif[name]) === 'undefined'){
                return [];
            }
            if(typeof($scope.classif[name][0].active) === 'undefined'){
                return $scope.classif[name];
            }
            return $filter('filter')($scope.classif[name], {active: 1});
        };
    }


	recalcBeneficiaries(wp) {
		if (!wp.beneficiaries) return;
		wp.beneficiaries.forEach(b => {
			const pct = parseFloat(b.completion) || 0;
			const beneficiaryValue = parseFloat(b.value) || 0;
			b.accepted_amount = parseFloat(((beneficiaryValue * pct) / 100).toFixed(2));
			b.rejected_amount = parseFloat((beneficiaryValue - b.accepted_amount).toFixed(2));
		});
	}

	autosavePostFields() {
		const postData = { workpackages: [] };

		for (const wp of this.workpackages) {
			if (wp.beneficiaries && !Array.isArray(wp.beneficiaries)) {
				wp.beneficiaries = Object.values(wp.beneficiaries);
			}

			if (Array.isArray(wp.beneficiaries) && wp.beneficiaries.length > 0) {
				this.recalcBeneficiaries(wp);
			}

			const wpData = {
				id:               wp.wp_id,
				completion_status: wp.completion_status,
				completion:        wp.completion,
				report_id:         wp.report_id,
				project_id:        wp.project_id,
				accepted:          wp.accepted,
				accepted_amount:   wp.accepted_amount,
				rejected_amount:   wp.rejected_amount,
				rejected_comment:  wp.rejected_comment || '',
				beneficiaries:     []
			};
			
			if(wp.initial_completed){
				wpData.noBen = true;
				wpData.completion_status = 0;
				wpData.completion = 0;
				wpData.accepted = 0;
				wpData.accepted_amount = 0;
				wpData.rejected_amount = 0;
				wpData.rejected_comment = '';
				wpData.beneficiaries = [{
					id:               0,
					acronym:          '',
					status:           0,
					report_id:        wp.report_id,
					project_id:       wp.project_id,
					completion:       0,
					accepted:         0,
					accepted_amount:  0,
					rejected_amount:  0,
					rejected_comment: ''
				}];
				postData.workpackages.push(wpData);
				continue;
			}
			
			
			let processBeneficiaries = (wp.completion_status == 1 && (wp.belongs_to_final_reporting || wp.is_Unit_or_FNLC));
			if (processBeneficiaries && Array.isArray(wp.beneficiaries) && wp.beneficiaries.length > 0) {
				for (const b of wp.beneficiaries) {
					const found = this.$filter('filter')(
						this.jsDataService.data.participants,
						{ id: b.participant_id },
						true
					);
					let participantId = found && found.length ? found[0].id : null;

					wpData.beneficiaries.push({
						id:               participantId,
						acronym:          b.acronym || '',
						status:           b.status || 0,
						report_id:        b.report_id,
						project_id:       b.project_id,
						completion:       b.completion || 0,
						accepted:         b.accepted || 0,
						accepted_amount:  b.accepted_amount || 0,
						rejected_amount:  b.rejected_amount || 0,
						rejected_comment: b.rejected_comment || ''
					});
				}
			} else {
				wpData.noBen = true;
				wpData.beneficiaries = [{
					id:               0,
					acronym:          '',
					status:           1,
					report_id:        wp.report_id,
					project_id:       wp.project_id,
					completion:       wp.completion || 0,
					accepted:         wp.accepted,
					accepted_amount:  wp.accepted_amount,
					rejected_amount:  wp.rejected_amount,
					rejected_comment: wp.rejected_comment || ''
				}];
			}

			postData.workpackages.push(wpData);
		}

		return postData;
	}


	getEstimatedAmountSecond() {
		return this.jsDataService.data.estimated_amount;
	}

	getInitialPrefinancingAmount() {
		return this.jsDataService.data.initial_amount;
	}

	getConsumptionPercentage() {
		let val = this.getInitialPrefinancingAmount() ? this.sumTotalGrant() * 100 / this.getInitialPrefinancingAmount() : 0;
		return  val.toFixed(2) + '%';
	}
	
	autosaveInit(form){
		let hasCompleted = false;
		for (const wp of this.workpackages) {
			if(wp.initial_completed){
				hasCompleted = true;
				break;
			}
		}
		if(hasCompleted){
			setTimeout(() => {form.save();}, 2000);
		}
	}
}
